module.exports = __webpack_public_path__ + "static/media/sample_vehicle_details.f2ee5c71.csv";